// extracted by mini-css-extract-plugin
export var userPageTabs = "user-page-tabs_FLaSbgqBnYnYPH1rzce7";